import React from "react"
import { useParams, useSearch, Link, useNavigate } from "@tanstack/react-router"
import { useDocument } from "@/lib/queries"
import { DocumentViewer } from "@/components/DocumentViewer"
import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"

export function DocumentViewerPage() {
  const { slug } = useParams({ strict: false }) as { slug: string }
  const search = useSearch({ strict: false }) as Record<string, string>
  const clinicalReviewSlug = search?.clinical_review
  const navigate = useNavigate()

  const { data: doc, isLoading, isError, error } = useDocument(
    slug,
    clinicalReviewSlug
  )

  // Determine back link from current path
  const path = window.location.pathname
  const baseBackTo = path.startsWith("/supplemental")
    ? "/supplemental"
    : path.startsWith("/pages")
      ? "/"
      : "/clinical-reviews"

  const handleBack = () => {
    navigate({ to: baseBackTo })
  }

  if (isLoading) {
    return <p className="p-6 text-muted-foreground">Loading document...</p>
  }

  if (isError) {
    return (
      <div className="p-6 space-y-4">
        <p className="text-destructive">
          {error instanceof Error ? error.message : "Failed to load document"}
        </p>
        <Link to={baseBackTo}>
          <Button variant="ghost" size="sm">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
        </Link>
      </div>
    )
  }

  if (!doc) return null

  const isStaticPage = path.startsWith("/pages")

  return (
    <div>
      {!isStaticPage && (
        <div className="px-6 pt-4">
          <Button variant="ghost" size="sm" onClick={handleBack}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
        </div>
      )}
      <div className="px-6 pb-6 pt-4">
        <DocumentViewer document={doc} />
      </div>
    </div>
  )
}
